// extracted by mini-css-extract-plugin
module.exports = {"file":"InputFile_file__0dfdr","fileCustom":"InputFile_fileCustom__gyB1N"};